// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zhAG","toggleWrap":"styles_toggleWrap__3gVJF","content":"styles_content__3A0QZ","selectAreaCode":"styles_selectAreaCode__3mFly"};